import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { shouldUseDOMEnvironment, Cast } from '@remirror/core';
import minDocument from 'min-document';
import { EditorView } from 'prosemirror-view';
import _extends from '@babel/runtime/helpers/extends';
import { jsx } from '@emotion/core';
import { mapProps, ReactSerializer } from '@remirror/react-renderer';

/**
 * A mock editor view used only when prosemirror is running on the server
 */
var EditorViewSSR =
/*#__PURE__*/
function () {
  _createClass(EditorViewSSR, [{
    key: "update",
    value: function update(_props) {}
  }, {
    key: "setProps",
    value: function setProps(_props) {}
  }, {
    key: "updateState",
    value: function updateState(_state) {}
  }, {
    key: "someProp",
    value: function someProp(_propName, f) {
      return f ? f(null) : null;
    }
  }, {
    key: "hasFocus",
    value: function hasFocus() {
      return false;
    }
  }, {
    key: "focus",
    value: function focus() {}
  }, {
    key: "posAtCoords",
    value: function posAtCoords(_coords) {
      return null;
    }
  }, {
    key: "coordsAtPos",
    value: function coordsAtPos(_pos) {
      return {
        bottom: 0,
        left: 0,
        right: 0,
        top: 0
      };
    }
  }, {
    key: "domAtPos",
    value: function domAtPos(_pos) {
      return {
        node: this.dom,
        offset: 0
      };
    }
  }, {
    key: "nodeDOM",
    value: function nodeDOM(_pos) {
      return null;
    }
  }, {
    key: "posAtDOM",
    value: function posAtDOM(_node, _offset, _bias) {
      return 0;
    }
  }, {
    key: "endOfTextblock",
    value: function endOfTextblock(_dir, _state) {
      return true;
    }
    /**
     * Removes the editor from the DOM and destroys all [node
     * views](#view.NodeView).
     */

  }, {
    key: "destroy",
    value: function destroy() {}
  }, {
    key: "dispatch",
    value: function dispatch(_tr) {}
  }]);

  function EditorViewSSR(place, props) {
    _classCallCheck(this, EditorViewSSR);

    _defineProperty(this, "dragging", null);

    this.place = place;
    this.props = props;
    var doc = minDocument;
    this.root = doc;
    this.dom = doc.createElement('div');
    this.state = props.state;
  }

  return EditorViewSSR;
}();
/**
 * Creates a new editor view
 *
 * @param place
 * @param props
 * @param forceEnvironment
 */

var createEditorView = function createEditorView(place, props, forceEnvironment) {
  var Constructor = shouldUseDOMEnvironment(forceEnvironment) ? EditorView : Cast(EditorViewSSR);
  return new Constructor(place, props);
};

/**
 * Remirror SSR component used for rendering in non dom environments
 */
var RemirrorSSR = function RemirrorSSR(_ref) {
  var attributes = _ref.attributes,
      manager = _ref.manager,
      state = _ref.state,
      editable = _ref.editable;
  var outerProps = mapProps(attributes);
  var ssrElement = ReactSerializer.fromExtensionManager(manager).serializeFragment(state.doc.content);
  var transformedElement = manager.ssrTransformer(ssrElement);
  return jsx("div", _extends({}, outerProps, {
    suppressContentEditableWarning: true,
    contentEditable: editable
  }), transformedElement);
};

export { EditorViewSSR, RemirrorSSR, createEditorView };
//# sourceMappingURL=react-ssr.esm.js.map
